module.exports = __webpack_public_path__ + "img/USERS.b0f4ad17.svg";